// Edit a unix-seconds timestamp via an HH:MM input. Date stays the same as the
// original timestamp (no date picker — adjusting "today's sleep started a few
// minutes earlier" is the dominant use case).

type Props = {
  label: string;
  value: number; // unix seconds
  onChange: (v: number) => void;
  hint?: string;
  min?: number; // optional clamp (seconds)
  max?: number;
};

export function TimePicker({ label, value, onChange, hint, min, max }: Props) {
  const date = new Date(value * 1000);
  const hh = String(date.getHours()).padStart(2, '0');
  const mm = String(date.getMinutes()).padStart(2, '0');

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '14px 16px',
        background: 'var(--bg-card)',
        borderRadius: 14,
        border: '1px solid var(--border)',
      }}
    >
      <div style={{ flex: 1 }}>
        <div
          style={{
            fontSize: 11,
            fontWeight: 600,
            color: 'var(--text-3)',
            textTransform: 'uppercase',
            letterSpacing: 0.04,
          }}
        >
          {label}
        </div>
        {hint && <div style={{ fontSize: 11, color: 'var(--text-3)', marginTop: 2 }}>{hint}</div>}
      </div>
      <input
        type="time"
        value={`${hh}:${mm}`}
        onChange={(e) => {
          const [h, m] = e.target.value.split(':').map(Number);
          if (Number.isNaN(h) || Number.isNaN(m)) return;
          const d = new Date(value * 1000);
          d.setHours(h, m, 0, 0);
          let next = Math.floor(d.getTime() / 1000);
          if (min != null && next < min) next = min;
          if (max != null && next > max) next = max;
          onChange(next);
        }}
        className="lt-mono lt-tabular"
        style={{
          background: 'var(--bg-sunken)',
          border: 'none',
          borderRadius: 8,
          padding: '6px 8px',
          fontSize: 16,
          fontWeight: 600,
          color: 'var(--text-1)',
        }}
      />
    </div>
  );
}
